import { ExternalLink } from 'lucide-react';
import { useMyPendingReviews } from '../../hooks/useMyHome';
import Spinner from '../ui/Spinner';

function timeAgo(dateStr: string): string {
  const now = Date.now();
  const then = new Date(dateStr).getTime();
  const diffMs = now - then;
  const diffMin = Math.floor(diffMs / 60_000);
  if (diffMin < 60) return `${diffMin}분 전`;
  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `${diffHour}시간 전`;
  const diffDay = Math.floor(diffHour / 24);
  return `${diffDay}일 전`;
}

export default function PendingReviews() {
  const { data: reviews, isLoading } = useMyPendingReviews();

  if (isLoading) return <Spinner />;

  // 0건이면 섹션 자체를 숨김
  if (!reviews || reviews.length === 0) return null;

  return (
    <div className="space-y-2">
      <p className="text-sm text-gray-500 mb-1">{reviews.length}건의 리뷰가 대기 중입니다</p>
      {reviews.map((r) => (
        <div
          key={r.reviewId}
          className="flex items-start justify-between gap-3 p-3 rounded-lg border border-gray-100 hover:border-gray-200 transition-colors"
        >
          <div className="min-w-0">
            <p className="text-sm font-medium text-gray-900 leading-snug">
              <span className="text-primary-600">PR #{r.prNumber}</span>{' '}
              {r.prTitle}
            </p>
            <p className="text-sm text-gray-400 mt-1">
              {r.projectName}
              {r.issueKey && <> · <span className="text-primary-500">{r.issueKey}</span></>}
              {' · '}요청자: {r.requesterName}
              {' · '}{timeAgo(r.requestedAt)}
            </p>
          </div>
          <a
            href={r.prUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 px-2.5 py-1.5 text-sm font-medium text-primary-600 bg-primary-50 rounded-md hover:bg-primary-100 transition-colors shrink-0"
          >
            리뷰하기 <ExternalLink className="size-3" />
          </a>
        </div>
      ))}
    </div>
  );
}
